module.exports = __webpack_public_path__ + "img/icon_card.0e3d1218.svg";